import Vue from "vue";
import "./UI";
import App from "./App.vue";
import router from "./router";
import "@/assets/icon/iconfont.css";

// markdown样式
import "github-markdown-css/github-markdown.css";
//路径会有些出入）
// 引入 ElementUI
import "@/assets/css/element-variables.scss";
// 全局样式
import "./assets/css/global.scss";

// 注册全局弹框组件
import Dialog from "./components/Dialog.vue";
// eslint-disable-next-line vue/multi-word-component-names
Vue.component("Dialog", Dialog);

import store from './store'
// eslint-disable-next-line no-unused-vars
import { saveAs } from "file-saver";
import { getCookieVal } from "@/tool/index";
Vue.config.productionTip = false;

//注册全局过滤器
import * as filters from "./filter";
Object.keys(filters).forEach((k) => Vue.filter(k, filters[k]));

import { allow, loadMore, tableHeight } from "./directive/index";

Vue.directive("allow", allow);
Vue.directive("loadMore", loadMore);
Vue.directive("tableHeight", tableHeight);

import { imageProcessMixin } from "./mixins/imageProcessMixin";

Vue.mixin(imageProcessMixin);

//这个方法需要放在new Vue之前，不然按F5刷新页面不会调用这个方法
router.beforeEach(function (to, from, next) {
  console.log(to);
  if (
    getCookieVal("iyuanwu_token").length != 0 ||
    to.path == "/pointDescription"
  ) {
    if (to.meta && to.meta.title) {
      document.title = to.meta.title; // 设置页面标题
    }
    next();
  } else {
    if (to.meta.login) {
      // 必须登录
      store.dispatch("setLoginShow", true)
    } else {
      next();
    }
  }
});
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
